import { ErrorWrapper } from './util'

import { OdooService } from './odoo.service'

const MODEL = 'x_enrollment'
// const DOMAIN = { }
// const REQUIRED_FIELDS = ['id', 'x_year']
// const BASIC_FIELDS = ['display_name', 'parent_id', 'is_company']

const BASIC_FIELDS = []
const OPTS = { limit: 0, order: 'id desc' }

export class EnrollmentsService extends OdooService {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super()
  }

  static get entity () {
    return 'fields'
  }

  static async read (ids, fields = []) {
    try {
      return await this.kwRead(MODEL, ids, [...BASIC_FIELDS, ...fields])
    } catch (error) {
      console.log(error)
    }
  }

  static async list (domain, fields = [], opts) {
    try {
      return await this.kwSearchRead(MODEL, domain, [...BASIC_FIELDS, ...fields], { ...OPTS, ...opts })
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async create (data) {
    try {
      if (data.x_year_id) {
        const x_year = await this.kwSearchRead('x_year', { id: data.x_year_id }, ['x_year'])
        data.x_year = x_year[0].x_year
      }
      return await this.kwCreate(MODEL, data)
    } catch (error) {
      console.error(error)
      throw new ErrorWrapper(error)
    }
  }

  static async delete (id) {
    try {
      return await this.kwDelete(MODEL, id)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async update (id, data) {
    try {
      // console.log(data)
      return await this.kwUpdate(MODEL, id, data)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async syncYears (yearId) {
    const SYNC_FIELDS = ['display_name', 'display_name', 'x_year_id', 'x_year', 'x_class_id']
    const domain = { x_year_id: yearId }

    try {
      const year = await this.kwSearchRead('x_year', { id: yearId }, ['display_name', 'id', 'x_year'])
      console.log('Year:', year)

      const enrollments = await this.kwSearchRead(MODEL, domain, SYNC_FIELDS)
      console.log('Enrollments for year:', year[0].x_year, ': ', enrollments.length)

      const syncPromises = enrollments.map(async enrollment => {
        if (!enrollment.x_year || enrollment.x_year === 'False') {
          await this.syncEnrollmentYear(enrollment.id, year[0].x_year)
        }
      })

      await Promise.all(syncPromises)
      console.log(`Updated ${syncPromises.length} out of ${enrollments.length} enrollments.`)

      return enrollments
    } catch (error) {
      console.error(error)
      throw new ErrorWrapper(error)
    }
  }

  static async syncEnrollmentYear (enrollmentId, yearName) {
    try {
      await this.kwUpdate(MODEL, [enrollmentId], { x_year: yearName })
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }
}
